import { Connection } from '@wix/cms-viewer-core'
import { BindingKeyManager } from '@wix/binding-key-manager'

export const adaptBuilderConnection = (builderConnection) => {
  const byItemIsInBuilderConnection = 'byItem' in builderConnection
  // TODO: Remove this check once the editor app switches to the builder
  // connection format in E3.
  // See: https://wix.slack.com/archives/C089HGCQTNV/p1767787023559159

  const properties = byItemIsInBuilderConnection
    ? Object.fromEntries(
      Object.entries(builderConnection.byItem).map(
        ([bindingKey, { config: { dataType, fieldKey, format, parentDataType } }]) => {
          const {
            id: propertyName,
            subItemId: subropertyName,
          } = BindingKeyManager.decode(bindingKey)
          const propertyPath = typeof subropertyName === 'undefined'
            ? propertyName
            : `${propertyName}.${subropertyName}`

          return [
            propertyPath,
            Connection.makePropertyConnectionToField({
              fieldKey,
              format,
              outputType: propertyPath === 'link'
                ? 'link'
                : dataType === 'text' || dataType === 'richText' || parentDataType
                  ? 'text' : 'unknown',
            }),
          ]
        },
      ),
    )
    : {}

  const linkBindingKey = BindingKeyManager.encode([], { type: 'dataItem', id: 'link' })
  const { [linkBindingKey]: { config: { data } } = { config: {} } } = byItemIsInBuilderConnection
    ? builderConnection.byItem
    : {}

  return Connection.make({ properties, data })
}
